/** MeetingSpeakerRenameModal — 说话人批量改名：改一次，这场会里所有该标签的分段都改。 */

import { useEffect } from "react";
import { Form, Input, Modal, Typography } from "antd";

const { Text } = Typography;

interface MeetingSpeakerRenameModalProps {
  open: boolean;
  from: string;
  submitting: boolean;
  onCancel: () => void;
  onSubmit: (to: string) => void;
}

export default function MeetingSpeakerRenameModal({
  open,
  from,
  submitting,
  onCancel,
  onSubmit,
}: MeetingSpeakerRenameModalProps) {
  const [form] = Form.useForm<{ to: string }>();

  useEffect(() => {
    if (open) form.setFieldsValue({ to: from });
  }, [open, from, form]);

  const handleOk = async () => {
    let values: { to: string };
    try {
      values = await form.validateFields();
    } catch {
      return;
    }
    onSubmit(values.to.trim());
  };

  return (
    <Modal
      title="改说话人名字"
      open={open}
      onCancel={onCancel}
      onOk={handleOk}
      okText="改名"
      confirmLoading={submitting}
      destroyOnHidden
      data-testid="meeting-speaker-rename-modal"
    >
      <Text type="secondary">
        改后这场会里所有标为「{from}」的分段一并改名，不影响其他会议。
      </Text>
      <Form form={form} layout="vertical" style={{ marginTop: "var(--jerry-sp-3)" }}>
        <Form.Item
          name="to"
          label="改为"
          rules={[{ required: true, message: "请输入说话人名字" }]}
        >
          <Input maxLength={50} data-testid="meeting-speaker-rename-input" />
        </Form.Item>
      </Form>
    </Modal>
  );
}
